import app from 'new-ui/app';
import { getUserCountry } from 'modules/user/utils';
import { formatTextToUseNewLineBeforeNumbers } from '../functions';
import { CHAT_ROLES } from '../constants';
import { sendMessage } from './api';

function updateOriginalJson(originalJson, modifiedJson) {
  let changesMade = false;

  for (const key in modifiedJson) {
    if (
      // eslint-disable-next-line
      modifiedJson.hasOwnProperty(key) &&
      // eslint-disable-next-line
      originalJson.hasOwnProperty(key) &&
      JSON.stringify(originalJson[key]) !== JSON.stringify(modifiedJson[key])
    ) {
      // eslint-disable-next-line no-param-reassign
      originalJson[key] = modifiedJson[key];
      changesMade = true;
    }
  }

  return changesMade;
}

const getUserSegment = () => {
  let segment = app?.coniguration?.userConfiguration?.userIntent?.user_type;
  if (!segment) {
    segment = 'treatment';
  } else {
    segment = segment.toLowerCase(); // Convert segment to lowercase
  }
  return segment;
};

export const formmatedlData = (
  data,
  trials,
  userSponsoredTrials,
  socTreatmentsCategories,
// eslint-disable-next-line consistent-return
) => {
  try {
    const toReturn = data;
    delete toReturn?.personal?.temp_id;
    delete toReturn?.personal?.is_done;
    delete toReturn?.personal?.answered_no_on_has_treatment_date;
    delete toReturn?.personal?.user_role;
    delete toReturn?.personal?.trialsCountBeforeExtraFilter;
    delete toReturn?.personal?.documents_data;
    delete toReturn?.personal?.providerCode;
    delete toReturn?.personal?.providerConsent;
    delete toReturn?.personal?.looking_for;

    // const temp = removeNullEmpty(toReturn.condition_profile);
    // toReturn.condition_profile = temp;

    delete toReturn?.condition_profile?.temp_id;

    toReturn.info.Fulladdress = toReturn?.info?.country?.label;
    toReturn.info.addressLat = getUserCountry(toReturn)?.location?.lat;
    toReturn.info.addressLng = getUserCountry(toReturn)?.location?.lng;
    delete toReturn?.info?.country;
    toReturn.socTreatments = app.treatments.slice(0, 15);
    toReturn.userNctList = trials;
    toReturn.numberOfTrialList = trials?.length ?? 0;
    toReturn.numberOfApprovedDrugs = app.treatments?.length ?? 0;
    toReturn.userSponsoredTrials = userSponsoredTrials;
    toReturn.userHaveSponseredTrialList = !!userSponsoredTrials?.length;
    toReturn.socTreatmentsCategories = socTreatmentsCategories;
    toReturn.userSegment = getUserSegment();
    toReturn.assistTrigBy = app.cache.assistTrigBy;

    toReturn.newSession = false;
    return toReturn;
  } catch { /* empty */ }
};

export const handleSendMessageByReturnUser = async (
  prompt,
  payload,
  addMessages,
) => {
  const response = await sendMessage(prompt, payload);

  addMessages([{
    content: formatTextToUseNewLineBeforeNumbers(response.msg),
    role: CHAT_ROLES.TINA,
  }]);

  if (response.dataToUpdate) {
    updateOriginalJson(app.user.condition_profile, response.dataToUpdate);
    // console.log('🚀 ~ isUpdate:', isUpdate);
    if (response.triggerProfileUpload === '1') {
      await app.handleUserUpdate();
    }
  }

  if (response.triggerTrialListUpdate === '1') {
    await app.handleUserUpdate();

    const { msg: messageContent } = await sendMessage(' Give me list of updated trials', payload);

    addMessages([{
      content: formatTextToUseNewLineBeforeNumbers(messageContent),
      role: CHAT_ROLES.TINA,
    }]);
  }

  return response;
};
